import { css } from 'styled-components';
import { level1Content } from '../../../styles/shareableStyles';

export const tileItemStyles = css`
  flex: 1;
  width: 100%;
  height: 74px;
  padding: 16px;
  transition: all 0.2s ease-in-out;
  ${level1Content};
`;
